<template>
  <el-date-picker
    style="width:100%"
    :type="type"
    :value-format="valueFormat"
    :format="valueFormat"
    :value="fildValue"
    @input="changeValue"
  />
</template>

<script>
const typeMap = {
  'yyyyMMddHHmmss': 'datetime',
  'yyyyMMdd': 'date',
  'yyMMdd': 'date',
  'yyyyMM': 'month',
  'yyMM': 'month',
  'MMddyyyy': 'date',
  'MMddyy': 'date',
  'MMdd': 'date',
  'yyyy': 'year',
  'yy': 'year'
}
export default {
  props: {
    value: {
      type: null,
      default: ''
    },
    item: {
      type: null,
      default: () => ({})
    },
    dateFormat: {
      type: String,
      default: 'yyyy-MM-dd'
    }
  },
  computed: {
    fildValue() {
      return this.value || null
    },
    valueFormat() {
      return this.dateFormat
    },
    type() {
      return typeMap[this.valueFormat] || 'date'
    }
  },
  methods: {
    changeValue(value) {
      this.$emit('input', value || '')
    }
  }
}
</script>
